import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { WebShopService } from "../services/webShop.service";

@Injectable({
  providedIn: "root"
})
export class WebshopServiceLocationResolver implements Resolve<number> {

  constructor(private _webShopService: WebShopService
    , private _router: Router) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<number> {
    const me = this;
    return new Promise<number>((resolve, reject) => {
      // Wait for webshop service to fully load (restore from storage)
      me._webShopService.getFullyLoadedObservable.subscribe(() => {
        if (me._webShopService.getServiceLocation()) {
          resolve(me._webShopService.getServiceLocation());
        } else {
          resolve(null);
          me._router.navigate(["/menuservice"]);
        }
      });
    });
  }
}